module.exports = __webpack_public_path__ + "img/labMedia.f324454d.svg";